module.exports = __webpack_public_path__ + "img/Gallery_1_02.ea80771c.jpeg";